import gql from 'graphql-tag'

export const listFormulars = gql`
query listFormulars($language: Language!, $type: FormularType!) {
	cashAssist {
		listFormulars(language: $language, type: $type) {
	    id
	    label: value
	    value: code
	  }
	}
}
`

export const getClosingsReport = gql`
query getClosingsReport($period: FullDateTimeIntervalInput!, $cashRegisterIds: [ID!], $departments: [String!], $groupBy: ClosingReportGroup, $params: ListQueryArgs, $pagination: ClosingsReportPaginationInput) {
	reports {
		getClosingsReport(period: $period, cashRegisterIds: $cashRegisterIds, departments: $departments, groupBy: $groupBy, params: $params, pagination: $pagination) {
			url
			pagination {
				cacheKey
				hasNext
				expectedUrl
			}
		}
	}
}`
